import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import useGet from '@/core/composables/api/useGet'
import type { Member } from '@/core/models/member/member'

export const useTeamMembers = () => {
  const route = useRoute()
  const teamId = computed(() => route.params.teamId as string)
  const endpoint = computed(() => `teams/${teamId.value}/members`)

  const { data: members, status, load } = useGet<Member[]>(endpoint)

  watch(
    teamId,
    async () => {
      await load()
    },
    { immediate: true },
  )

  return {
    teamId,
    members,
    status,
  }
}
